export const FEATURE_TOGGLE = {
  GroupChat: 'v2.2402.06_group-chat',
  AllowClientCreateLTA: 'v2.2402.06_lta-feature-for-client',
  CheckNearByAddress: 'v2.2402.06_check-nearby-address',
  BillingAccountOrderCreation: 'v2.2402.20_billing-account-order-creation',
  InvoiceOvertime: 'invoice-overtime',
  WorkerRating: 'worker-rating',
  HideBrokenReports: 'hide-broken-reports',
  GenerateManualInvoices: 'v2.2403.05_generate_manual_invoices',
  CustomWorkWeek: 'v2.2403.19_custom-work-week',
  InvoiceDetailsRevamp: 'v2.2403.19_invoice-page-revamp',
  DownloadInvoicePdf: 'v2.2404.16_download-invoice',
  InvoiceSweepRule: 'v2.2403.19_invoice-sweep-rule',
  InvoiceGroupRule: 'v2.2404.02_invoice-break-rule',
  RegionFeature: 'v2.2404.16_region-zip-code-web',
};
